/**
 * Created by saeed on 12/29/2016.
 */
import {Injectable} from '@angular/core';
import {Http, Response, Headers, RequestOptions} from '@angular/http';
import {Observable} from 'rxjs/Rx';

// Import RxJs required methods
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import {
  API_URL_TEST_GET_TRANS_DETAIL_AP,
  API_URL_TEST_MAKE_ONLINE_PAYMENT_AP, API_URL_TEST_MAKE_ONLINE_PAYMENT_SEP, API_URL_TEST_VERIFY_ONLINE_PAYMENT_AP

} from '../constants';
import {BaseHttpService} from "../base-http-service";

@Injectable()
export class TestService {
  // Resolve HTTP using the constructor
  constructor(private http: BaseHttpService) {


  }

  makeTestOnlinePaymentAP(localInvoiceId: number,keyUrl:string): Observable<any> {
    return this.http.get(API_URL_TEST_MAKE_ONLINE_PAYMENT_AP + '?localInvoiceId=' + localInvoiceId +'&companyKeyUrl='+keyUrl)
    // ...and calling .json() on the response to return data
      .map((res: Response) => {
        return res;
      })
      //...errors if any
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }

  verifyTestOnlinePaymentAP(localInvoiceId: number,keyUrl:string): Observable<any> {
    return this.http.get(API_URL_TEST_VERIFY_ONLINE_PAYMENT_AP+ '?localInvoiceId=' + localInvoiceId +'&companyKeyUrl='+keyUrl)
    // ...and calling .json() on the response to return data
      .map((res: Response) => {
        return res;
      })
      //...errors if any
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }

  getTransDetailAP(localInvoiceId: number,keyUrl:string): Observable<any> {
    return this.http.get(API_URL_TEST_GET_TRANS_DETAIL_AP+ '?localInvoiceId=' + localInvoiceId +'&companyKeyUrl='+keyUrl)
    // ...and calling .json() on the response to return data
      .map((res: Response) => {
        return res;
      })
      //...errors if any
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }

  makeTestOnlinePaymentSEP(localInvoiceId: number,keyUrl:string): Observable<any> {
    return this.http.get(API_URL_TEST_MAKE_ONLINE_PAYMENT_SEP + '?localInvoiceId=' + localInvoiceId +'&companyKeyUrl='+keyUrl)
    // ...and calling .json() on the response to return data
      .map((res: Response) => {
        return res;
      })
      //...errors if any
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }

}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/services/test-services/test.service.ts